import React from 'react';

import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './personal-plan-hero-skeleton.module.less';

/** One placeholder per stat in the loaded hero band. */
const STAT_PLACEHOLDER_COUNT = 4;

const SkeletonBlock = ({className}: {className: string}) => (
    <div className={className}>
        <BlockSkeleton className={styles['fill']} />
    </div>
);

/**
 * Loading state for the revamped Personal Plan hero. Mirrors the loaded layout with a
 * banner-sized placeholder above a row of four stat placeholders.
 */
export const PersonalPlanHeroSkeleton = () => {
    return (
        <div className={styles['skeleton']} data-testid="personal-plan-hero-skeleton">
            <div className={styles['banner-wrapper']}>
                <SkeletonBlock className={styles['banner']} />
            </div>
            <div className={styles['stats']}>
                {Array.from({length: STAT_PLACEHOLDER_COUNT}, (_, index) => (
                    <SkeletonBlock className={styles['stat']} key={index} />
                ))}
            </div>
        </div>
    );
};
